// extracted by mini-css-extract-plugin
export default {"collapse":"collapse_collapse__RuLDn"};